import httpUtils from '@/utils/http-utils';
import i18n from '@/plugins/vue-i18n';

const baseRequesterOptions = {
  baseUrl: `${window.processEnv.VUE_APP_CMS_API_BASE_URL_V1}/products`,
  // baseUrl: `${window.processEnv.VUE_APP_CMS_API_BASE_URL}/products`,
  requesterType: 'CMS_WEB_SERVICE',
};

const baseRequesterOptionsC = {
  baseUrl: `${window.processEnv.VUE_APP_CMS_API_BASE_URL}`,
  requesterType: 'CMS_WEB_SERVICE',
}

const baseRequesterOptionsA = {
  baseUrl: `${window.processEnv.VUE_APP_CMS_API_BASE_URL}/products`,
  requesterType: 'CMS_WEB_SERVICE',
};

const baseRequesterOptionsB = {
  baseUrl: `${window.processEnv.VUE_APP_CMS_API_BASE_URL_V1}/product-inventories`,
  // baseUrl: `${window.processEnv.VUE_APP_CMS_API_BASE_URL}/products`,
  requesterType: 'CMS_WEB_SERVICE',
};

const productApiReqNotification = httpUtils.createRequester(baseRequesterOptions);
const productApiReqErrorHandling = httpUtils.createRequester(baseRequesterOptions, 'errorHandling');

const productApiReqNotificationA = httpUtils.createRequester(baseRequesterOptionsA);
const productApiReqErrorHandlingA = httpUtils.createRequester(baseRequesterOptionsA, 'errorHandling');

const productApiReqNotificationB = httpUtils.createRequester(baseRequesterOptionsB);
const productApiReqErrorHandlingB = httpUtils.createRequester(baseRequesterOptionsB, 'errorHandling');

const productApiReqNotificationC = httpUtils.createRequester(baseRequesterOptionsC);
const productApiReqErrorHandlingC = httpUtils.createRequester(baseRequesterOptionsC, 'errorHandling');

const getRequester = (errorManagementType) => {
  if (errorManagementType === 'errorHandling') {
    return productApiReqErrorHandling;
  }

  return productApiReqNotification;
};

// eslint-disable-next-line no-unused-vars
const getRequesterA = (errorManagementType) => {
  if (errorManagementType === 'errorHandling') {
    return productApiReqErrorHandlingA;
  }
  return productApiReqNotificationA;
};

const getRequesterB = (errorManagementType) => {
  if (errorManagementType === 'errorHandling') {
    return productApiReqErrorHandlingB;
  }
  return productApiReqNotificationB;
};

const getRequesterC = (errorManagementType) => {
  if (errorManagementType === 'errorHandling') {
    return productApiReqErrorHandlingC;
  }
  return productApiReqNotificationC;
};

class ProductApi {
  fetchProducerProduct(filters = {}, errorManagementType) {
    let taxInc = undefined;
    if (filters.maxPrice && filters.maxPrice != null && filters.tax) {
      taxInc = filters.tax == 'IN' ?
        {
          minPriceTaxIn: filters.minPrice != null ? filters.minPrice : undefined,
          maxPriceTaxIn: filters.maxPrice != null ? filters.maxPrice : undefined
        } :
        {
          minPrice: filters.minPrice != null ? filters.minPrice : undefined,
          maxPrice: filters.maxPrice != null ? filters.maxPrice : undefined
        };
    }
    return getRequester(errorManagementType)
      .get('/search/', {
        // .get('/elastic', {
        headers: {
          'accept-language': i18n.locale,
        },
        params: {
          page: filters.page,
          // size: filters.size,
          type: filters.productTypes,
          // inventory: filters.availability,
          a: filters.attributes,
          c: filters.countries,
          r: filters.regions,
          t: filters.text,
          sortByPrice: filters.sortByPrice,
          sortByQty: filters.sortByQty,
          show: filters.show,
          providerId:filters.providerId ? filters.providerId : undefined,
          sortByOrigin:"ASC",
          ...taxInc
        },
      }).then(res => res && res.data);
  }
  fetchProductsBoutique(filters = {}, errorManagementType) {
    return getRequesterB(errorManagementType)
      .get('/search/', {
        // .get('/elastic', {
        headers: {
          'accept-language': i18n.locale,
        },
        params: {
          page: filters.page,
          size: filters.size,
          type: filters.productTypes,
          inventory: filters.availability,
          a: filters.attributes,
          c: filters.countries,
          r: filters.regions,
          t: filters.text,
          min: filters.minPrice,
          max: filters.maxPrice,
          show: filters.show,
          sortByPrice: 'DESC',
          sortByQty: filters.sortByQty,
          providerId:filters.providerId ? filters.providerId : undefined,
          sortByOrigin:"ASC",
        },
      }).then(res => res && res.data);
  }

  fetchProducts(filters = {}, errorManagementType) {
    let taxInc = undefined;
    if (filters.maxPrice && filters.maxPrice != null && filters.tax) {
      taxInc = filters.tax == 'IN' ?
        {
          minPriceTaxIn: filters.minPrice != null ? filters.minPrice : undefined,
          maxPriceTaxIn: filters.maxPrice != null ? filters.maxPrice : undefined
        } :
        {
          minPrice: filters.minPrice != null ? filters.minPrice : undefined,
          maxPrice: filters.maxPrice != null ? filters.maxPrice : undefined
        };
    }
    return getRequesterB(errorManagementType)
      .get('/search/', {
        // .get('/elastic', {
        headers: {
          'accept-language': i18n.locale,
        },
        params: {
          page: filters.page,
          size: filters.size,
          type: filters.productTypes,
          inventory: filters.availability,
          a: filters.attributes,
          c: filters.countries,
          r: filters.regions,
          t: filters.text,
          sortByPrice: filters.sortByPrice,
          sortByQty: filters.sortByQty,
          show: filters.show,
          providerId:filters.providerId ? filters.providerId : undefined,
          sortByOrigin:"ASC",
          ...taxInc
        },
      }).then(res => res && res.data);
  }
  downloadPDF(filters = {}, errorManagementType) {
    let taxInc = undefined;
    if (filters.maxPrice && filters.maxPrice != null && filters.tax) {
      taxInc = filters.tax == 'IN' ?
        {
          minPriceTaxIn: filters.minPrice != null ? filters.minPrice : undefined,
          maxPriceTaxIn: filters.maxPrice != null ? filters.maxPrice : undefined
        } :
        {
          minPrice: filters.minPrice != null ? filters.minPrice : undefined,
          maxPrice: filters.maxPrice != null ? filters.maxPrice : undefined
        };
    }
    return getRequesterB(errorManagementType)
    .get('/listing/', {
      // .get('/elastic', {
      headers: {
        'accept-language': i18n.locale,
      },
      params: {
        page: filters.page,
        size: filters.size,
        type: filters.productTypes,
        inventory: filters.availability,
        a: filters.attributes,
        c: filters.countries,
        r: filters.regions,
        t: filters.text,
        sortByPrice: filters.sortByPrice,
        sortByQty: filters.sortByQty,
        show: filters.show,
        providerId:filters.providerId ? filters.providerId : undefined,
        ...taxInc
      },
      responseType: 'blob',
    }).then(res => res && res.data);

  }

  fetchProductsByPuid(filters = [], errorManagementType) {
    if (!Array.isArray(filters)) {
      filters = [filters];
  }
    const queryString = filters
            .map(puid => `puid=${encodeURIComponent(puid)}`)
            .join('&');
    return getRequesterB(errorManagementType)
      .get(`search/?${queryString}`, {
        headers: {
          'accept-language': i18n.locale,
        },
      }).then(res => res && res.data);
  }

  fetchProduct(id, idType, errorManagementType) {

    return getRequesterB(errorManagementType)
      .get(`/search/${id}`, {
        // .get(`/${id}`, {
        headers: {
          'accept-language': i18n.locale,
        },
        params: {
          idType,
        },
      }).then(res => res && res.data);
  }

  fetchProductInv(id, idType, errorManagementType) {

    return getRequester(errorManagementType)
      .get(`/search/${id}`, {
        // .get(`/${id}`, {
        headers: {
          'accept-language': i18n.locale,
        },
        params: {
          idType,
        },
      }).then(res => res && res.data);
  }

  fetchProductBoutique(id, idType, errorManagementType) {

    return getRequesterB(errorManagementType)
      .get(`/search/${id}`, {
        // .get(`/${id}`, {
        headers: {
          'accept-language': i18n.locale,
        },
        params: {
          idType,
        },
      }).then(res => res && res.data);
  }

  getSingleProduct(id, idType, errorManagementType) {
    return getRequester(errorManagementType)
      .get(`/search/${id}`, {
        headers: {
          'accept-language': i18n.locale,
        },
        params: {
          idType,
        },
      }).then(res => res && res.data);
  }

  fetchCarouselProducts(group, errorManagementType) {
    return getRequesterC(errorManagementType)
      .get('/carousels', {
        headers: {
          'accept-language': i18n.locale,
        },
        params: {
          group,
        },
      }).then(res => res && res.data);
  }
}

export default new ProductApi();
